var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransaction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.97557 9.59085L2.39557 9.43785C4.24457 4.68785 9.55357 1.98384 14.7286 3.32784C20.2416 4.76084 23.5166 10.2458 22.0426 15.5778C20.8236 19.9888 16.7386 22.9148 12.2426 22.9838",
    stroke: "#FEC200",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3958 22.9841C6.89575 22.9841 2.39575 17.9841 2.39575 11.9841M13.9998 10.7062C13.6478 10.3362 12.7868 9.46915 11.4248 10.0862C10.0638 10.7012 9.84775 12.6822 11.9068 12.8932C12.8368 12.9882 13.4438 12.7831 13.9998 13.3631C14.5558 13.9451 14.6588 15.5611 13.2388 15.9971C11.8188 16.4331 10.8978 15.7131 10.6508 15.4881M12.3038 9.00415V9.79415M12.3038 16.1312V17.0042",
    stroke: "#FEC200",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransaction);
export default __webpack_public_path__ + "static/media/transaction.a97c1b7223b7148f33139301a637aed6.svg";
export { ForwardRef as ReactComponent };